/**
 * Spring Boot REST API
 * \"Spring Boot REST API for Online Store\"
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, injectable, named } from "inversify";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Headers } from "../Headers";
import { HttpResponse } from "../HttpResponse";
import { IAPIConfiguration } from "../IAPIConfiguration";
import { IHttpClient } from "../IHttpClient";

import { AddUserReq } from "../model/addUserReq";
import { AddUserRes } from "../model/addUserRes";
import { AppHqErrorResponse } from "../model/appHqErrorResponse";
import { CaptchaFrontEndData } from "../model/captchaFrontEndData";
import { FElogging } from "../model/fElogging";
import { Response } from "../model/response";
import { UserAppResList } from "../model/userAppResList";
import { UserDetailsRes } from "../model/userDetailsRes";

import { COLLECTION_FORMATS } from "../variables";
import { UserProfileServiceInterface } from "./userProfile.serviceInterface";

@injectable()
export class UserProfileService implements UserProfileServiceInterface {
  private basePath: string = "http://localhost/api";

  constructor(
    @inject(IHttpClient)
    @named("UserProfileService")
    private httpClient: IHttpClient,
    @inject(IAPIConfiguration)
    @named("UserProfileService")
    private APIConfiguration: IAPIConfiguration
  ) {
    if (this.APIConfiguration.basePath) {
      this.basePath = this.APIConfiguration.basePath;
    }
  }

  /**
   * activationApprovedByCustomer
   * @param id id
   * @param username username
   */
  public activationApprovedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public activationApprovedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  public activationApprovedByCustomerUsingPUT(
    id: string,
    username: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (id == null) {
      throw new Error(
        "Required parameter id was null or undefined when calling activationApprovedByCustomerUsingPUT."
      );
    }

    if (username == null) {
      throw new Error(
        "Required parameter username was null or undefined when calling activationApprovedByCustomerUsingPUT."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<AddUserRes>> = this.httpClient.put(
      `${this.basePath}/apphq/user/${encodeURIComponent(
        String(username)
      )}/admin/company/${encodeURIComponent(String(id))}/activation/approved`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as AddUserRes)
      );
    }
    return response;
  }

  /**
   * activationApprovedByRhenus
   * @param username username
   */
  public activationApprovedByRhenusUsingPUT(
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public activationApprovedByRhenusUsingPUT(
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  public activationApprovedByRhenusUsingPUT(
    username: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (username == null) {
      throw new Error(
        "Required parameter username was null or undefined when calling activationApprovedByRhenusUsingPUT."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<AddUserRes>> = this.httpClient.put(
      `${this.basePath}/apphq/user/${encodeURIComponent(
        String(username)
      )}/superuser/activation/approved`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as AddUserRes)
      );
    }
    return response;
  }

  /**
   * activationRejectedByCustomer
   * @param id id
   * @param username username
   */
  public activationRejectedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public activationRejectedByCustomerUsingPUT(
    id: string,
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public activationRejectedByCustomerUsingPUT(
    id: string,
    username: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (id == null) {
      throw new Error(
        "Required parameter id was null or undefined when calling activationRejectedByCustomerUsingPUT."
      );
    }

    if (username == null) {
      throw new Error(
        "Required parameter username was null or undefined when calling activationRejectedByCustomerUsingPUT."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<any>> = this.httpClient.put(
      `${this.basePath}/apphq/user/${encodeURIComponent(
        String(username)
      )}/admin/company/${encodeURIComponent(String(id))}/activation/rejected`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * activationRejectedByRhenus
   * @param username username
   */
  public activationRejectedByRhenusUsingPUT(
    username: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public activationRejectedByRhenusUsingPUT(
    username: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public activationRejectedByRhenusUsingPUT(
    username: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (username == null) {
      throw new Error(
        "Required parameter username was null or undefined when calling activationRejectedByRhenusUsingPUT."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<any>> = this.httpClient.put(
      `${this.basePath}/apphq/user/${encodeURIComponent(
        String(username)
      )}/superuser/activation/rejected`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * audio
   * @param audioType audioType
   */
  public audioUsingGET(
    audioType: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public audioUsingGET(
    audioType: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public audioUsingGET(
    audioType: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (audioType == null) {
      throw new Error(
        "Required parameter audioType was null or undefined when calling audioUsingGET."
      );
    }

    headers.Accept = "";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/apphq/captcha/audio/${encodeURIComponent(
        String(audioType)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * audio
   */
  public audioUsingGET1(observe?: "body", headers?: Headers): Observable<any>;
  public audioUsingGET1(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public audioUsingGET1(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    headers.Accept = "";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/apphq/captcha/audio`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * Get all pending activation for Customer.
   * @param id id
   */
  public getAllPendingActivationForCustomer(
    id: string,
    observe?: "body",
    headers?: Headers
  ): Observable<any[]>;
  public getAllPendingActivationForCustomer(
    id: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any[]>>;
  public getAllPendingActivationForCustomer(
    id: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (id == null) {
      throw new Error(
        "Required parameter id was null or undefined when calling getAllPendingActivationForCustomer."
      );
    }

    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<any[]>> = this.httpClient.get(
      `${this.basePath}/apphq/user/admin/company/${encodeURIComponent(
        String(id)
      )}/activation/pending`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any[])
      );
    }
    return response;
  }

  /**
   * Get all pending activation for Rhenus.
   */
  public getAllPendingActivationForRhenus(
    observe?: "body",
    headers?: Headers
  ): Observable<any[]>;
  public getAllPendingActivationForRhenus(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any[]>>;
  public getAllPendingActivationForRhenus(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<HttpResponse<any[]>> = this.httpClient.get(
      `${this.basePath}/apphq/user/superuser/activation/pending`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any[])
      );
    }
    return response;
  }

  /**
   * Get image by index.
   * @param index index
   */
  public getImage(
    index: number,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public getImage(
    index: number,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public getImage(
    index: number,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (index == null) {
      throw new Error(
        "Required parameter index was null or undefined when calling getImage."
      );
    }

    headers.Accept = "";

    const response: Observable<HttpResponse<any>> = this.httpClient.get(
      `${this.basePath}/apphq/captcha/image/${encodeURIComponent(
        String(index)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * Get user details for logged in user
   */
  public getUser(
    observe?: "body",
    headers?: Headers
  ): Observable<UserDetailsRes>;
  public getUser(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<UserDetailsRes>>;
  public getUser(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<UserDetailsRes>
    > = this.httpClient.get(`${this.basePath}/apphq/user`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) => httpResponse.payload as UserDetailsRes
        )
      );
    }
    return response;
  }

  /**
   * Get all apps the logged in user has access to
   */
  public getUserApps(
    observe?: "body",
    headers?: Headers
  ): Observable<UserAppResList>;
  public getUserApps(
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<UserAppResList>>;
  public getUserApps(
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    // authentication (spring_oauth) required
    if (this.APIConfiguration.accessToken) {
      const accessToken =
        typeof this.APIConfiguration.accessToken === "function"
          ? this.APIConfiguration.accessToken()
          : this.APIConfiguration.accessToken;
      headers.Authorization = "Bearer " + accessToken;
    }
    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<UserAppResList>
    > = this.httpClient.get(`${this.basePath}/apphq/user/apps`, headers);
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) => httpResponse.payload as UserAppResList
        )
      );
    }
    return response;
  }

  /**
   * User sign up
   * @param addUserReq addUserReq
   */
  public signUpUser(
    addUserReq: AddUserReq,
    observe?: "body",
    headers?: Headers
  ): Observable<any>;
  public signUpUser(
    addUserReq: AddUserReq,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<any>>;
  public signUpUser(
    addUserReq: AddUserReq,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (addUserReq == null) {
      throw new Error(
        "Required parameter addUserReq was null or undefined when calling signUpUser."
      );
    }

    headers.Accept = "application/json";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<any>> = this.httpClient.post(
      `${this.basePath}/apphq/signup`,
      addUserReq,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as any)
      );
    }
    return response;
  }

  /**
   * Initialize
   * @param howMany howMany
   */
  public start(
    howMany: string,
    observe?: "body",
    headers?: Headers
  ): Observable<CaptchaFrontEndData>;
  public start(
    howMany: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<CaptchaFrontEndData>>;
  public start(
    howMany: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (howMany == null) {
      throw new Error(
        "Required parameter howMany was null or undefined when calling start."
      );
    }

    headers.Accept = "application/json";

    const response: Observable<
      HttpResponse<CaptchaFrontEndData>
    > = this.httpClient.get(
      `${this.basePath}/apphq/captcha/start/${encodeURIComponent(
        String(howMany)
      )}`,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map(
          (httpResponse: HttpResponse) =>
            httpResponse.payload as CaptchaFrontEndData
        )
      );
    }
    return response;
  }

  /**
   * User activation
   * @param token token
   */
  public userActivation(
    token: string,
    observe?: "body",
    headers?: Headers
  ): Observable<AddUserRes>;
  public userActivation(
    token: string,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<AddUserRes>>;
  public userActivation(
    token: string,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (token == null) {
      throw new Error(
        "Required parameter token was null or undefined when calling userActivation."
      );
    }

    headers.Accept = "application/json";

    const response: Observable<HttpResponse<AddUserRes>> = this.httpClient.put(
      `${this.basePath}/apphq/activation/${encodeURIComponent(String(token))}`,
      undefined,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as AddUserRes)
      );
    }
    return response;
  }

  /**
   * Endpoint to log FE logs
   * @param log log
   */
  public webLogging(
    log: FElogging,
    observe?: "body",
    headers?: Headers
  ): Observable<Response>;
  public webLogging(
    log: FElogging,
    observe?: "response",
    headers?: Headers
  ): Observable<HttpResponse<Response>>;
  public webLogging(
    log: FElogging,
    observe: any = "body",
    headers: Headers = {}
  ): Observable<any> {
    if (log == null) {
      throw new Error(
        "Required parameter log was null or undefined when calling webLogging."
      );
    }

    headers.Accept = "*/*";
    headers["Content-Type"] = "application/json";

    const response: Observable<HttpResponse<Response>> = this.httpClient.post(
      `${this.basePath}/apphq/web/log`,
      log,
      headers
    );
    if (observe === "body") {
      return response.pipe(
        map((httpResponse: HttpResponse) => httpResponse.payload as Response)
      );
    }
    return response;
  }
}
